<div #container class="case-spinner--container">
  <div #roll class="case-spinner--spinner">
    @for (spinnerItem of spinnerItems(); track index; let index = $index) {

    <div class="case-spinner--skin" style="--color: {{ spinnerItem.color }}">
      <img
        class="case-spinner--skin-image"
        [src]="spinnerItem.image"
        [alt]="spinnerItem.name"
        loading="lazy"
      />
      @let wonItem = showResults() && wonIndex() === index; @if (wonItem) {
      <div class="case-spinner--skin-details" [@scaleIn]>
        <span class="case-spinner--skin-name">
          {{ spinnerItem.name }}
        </span>
        <app-cost
          class="case-spinner--skin-price"
          color="var(--yellow)"
          [cost]="spinnerItem.price"
          [balanceType]="player()?.balance ?? 'skins'"
        />
      </div>
      }
    </div>
    }
  </div>
</div>
